function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
// setInterval(countDown, 1000);
// function countDown() {
//   const countCardSections = document.querySelectorAll('.countd_all');
//   countCardSections.forEach((countdownSection) => {
//     var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
//     var now = new Date().getTime();
//     var distance = countDownDate - now;
//     if (distance < 0 || isNaN(countDownDate)) {
//       countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
//       countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
//       countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
//       countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
//     }
//     else {
//       countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
//       countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
//     }
//   });
// }


document.addEventListener('DOMContentLoaded', () => {
  const countdowns = [];
  document.querySelectorAll('.countd_all').forEach(section => {
    const targetDate = new Date(section.dataset.date).getTime();
    countdowns.push({
      targetDate,
      days: section.querySelector('.wb_cdays'),
      hours: section.querySelector('.wb_chours'),
      minutes: section.querySelector('.wb_cminutes'),
      seconds: section.querySelector('.wb_cseconds')
    });
  });
  if (!countdowns.length) return;
  let timerStarted = false;
  let timerId = null;
  function updateCountdowns() {
    const now = Date.now();
    countdowns.forEach(item => {
      if (isNaN(item.targetDate)) return;
      const distance = item.targetDate - now;
      if (distance <= 0) {
        item.days && (item.days.textContent = '00');
        item.hours && (item.hours.textContent = '00');
        item.minutes && (item.minutes.textContent = '00');
        item.seconds && (item.seconds.textContent = '00');
        return;
      }
      item.days && (item.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0'));
      item.hours && (item.hours.textContent = String(Math.floor((distance % 86400000) / 3600000)).padStart(2, '0'));
      item.minutes && (item.minutes.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, '0'));
      item.seconds && (item.seconds.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, '0'));
    });
    timerId = setTimeout(updateCountdowns, 1000);
  }
  function startCountdown() {
    if (timerStarted) return;
    timerStarted = true;
    updateCountdowns();
  }
  const firstCountdown = document.querySelector('.countd_all');
  if (firstCountdown) {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        window.requestIdleCallback
          ? requestIdleCallback(startCountdown)
          : setTimeout(startCountdown, 2000);
      }
    }, {
      rootMargin: '200px'
    });
    observer.observe(firstCountdown);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(timerId);
      timerStarted = false;
    } else if (firstCountdown && firstCountdown.getBoundingClientRect().top < window.innerHeight) {
      startCountdown();
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const countdowns = Array.from(document.querySelectorAll(".countd_all")).map((section) => {
//     return {
//       section,
//       endTime: new Date(section.getAttribute("data-date")).getTime(),
//       days: section.querySelector(".main_cdays .wb_cdays"),
//       hours: section.querySelector(".main_chours .wb_chours"),
//       minutes: section.querySelector(".main_cminutes .wb_cminutes"),
//       seconds: section.querySelector(".main_cseconds .wb_cseconds"),
//       expired: false
//     };
//   });

//   if (!countdowns.length) return;

//   function setValue(item, days, hours, minutes, seconds) {
//     if (item.days) item.days.textContent = String(days).padStart(2, "0");
//     if (item.hours) item.hours.textContent = String(hours).padStart(2, "0");
//     if (item.minutes) item.minutes.textContent = String(minutes).padStart(2, "0");
//     if (item.seconds) item.seconds.textContent = String(seconds).padStart(2, "0");
//   }

//   function countDown() {
//     const now = Date.now();
//     let activeCount = 0;

//     countdowns.forEach((item) => {
//       if (item.expired) return;

//       const distance = item.endTime - now;

//       if (!item.endTime || isNaN(item.endTime) || distance <= 0) {
//         setValue(item, 0, 0, 0, 0);
//         item.expired = true;
//         return;
//       }

//       activeCount++;

//       setValue(
//         item,
//         Math.floor(distance / (1000 * 60 * 60 * 24)),
//         Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
//         Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
//         Math.floor((distance % (1000 * 60)) / 1000)
//       );
//     });

//     if (activeCount === 0) {
//       clearInterval(timer);
//     }
//   }

//   countDown();
//   const timer = setInterval(countDown, 1000);
// });